import { render, staticRenderFns } from "./DaignosticCategory.vue?vue&type=template&id=5a6ee54c&"
import script from "./DaignosticCategory.vue?vue&type=script&lang=js&"
export * from "./DaignosticCategory.vue?vue&type=script&lang=js&"
import style0 from "./DaignosticCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports